export default __webpack_public_path__ + "static/media/team-jorge.84602b29.webp";